import instance from './AxiosServices';

const EventService = {
  getDashboardStats: async () => {
    return instance.get('/events/partners/dashboard-stats');
  },

  getAllPartnerEvents: async () => {
    return instance.get('/events/partners/all');
  },

  getEventById: async (id) => {
    return instance.get(`/events/partners/event/${id}`);
  },

  getEventAnalytics: async (id) => {
    return instance.get(`/events/partners/event/${id}/analytics`);
  },

  createEvent: async (eventData) => {
    return instance.post('/events/partners/add', eventData);
  },

  updateEvent: async (id, eventData) => {
    return instance.put(`/events/partners/event/${id}`, eventData);
  },

  getCategories: async () => {
    return instance.get('/category');
  },

  getAttendees: async () => {
    return instance.get('/events/partners/attendees');
  },

  toggleCheckIn: async (id) => {
    return instance.post('/events/partners/check-in-toggle', { id });
  },

  createStaff: async (staffData) => {
    return instance.post('/staff/partners/create', staffData);
  },

  getStaffList: async () => {
    return instance.get('/staff/partners/list');
  },

  deleteStaff: async (id) => {
    return instance.delete(`/staff/partners/${id}`);
  },

  getActiveEvents: async () => {
    return instance.get('/staff/partners/events');
  },

  updateStaffEvents: async (id, assignedEvents) => {
    return instance.put(`/staff/partners/${id}/events`, { assignedEvents });
  }
};

export default EventService;
